import { CommonModule } from '@angular/common';
import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  Renderer2
} from '@angular/core';

export interface ContactModalItem {
  carreras: string[];
  email: string;
}

export interface ContactModalList {
  titulo: string;
  items: ContactModalItem[];
}

export interface ContactModalData {
  titulo?: string;
  listas: ContactModalList[];
}

@Component({
  selector: 'app-modal-contacto-facultad',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-contacto-facultad.component.html',
  styleUrl: './modal-contacto-facultad.component.scss'
})
export class ModalContactoFacultadComponent implements OnDestroy {
  @Input() data: any;
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  // Mock temporal. La estructura coincide con la que recibirá el componente desde el backend.


  constructor(private readonly renderer: Renderer2) {}


  ngOnChanges(): void {
    this.updateBodyScrollLock();
  }

  closeModal(): void {
    this.closed.emit();
  }

  onOverlayClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }

  @HostListener('document:keydown.escape')
  closeWithEscape(): void {
    if (this.isOpen) {
      this.closeModal();
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'facultad-modal-open');
  }

  private updateBodyScrollLock(): void {
    if (this.isOpen) {
      this.renderer.addClass(document.body, 'facultad-modal-open');
    } else {
      this.renderer.removeClass(document.body, 'facultad-modal-open');
    }
  }
}
